import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, switchMap } from 'rxjs/operators';

import { AuthFacade } from '@aw/prypco/state/auth';

export const oryAuthGuard: CanActivateFn = () => {
  const authFacade = inject(AuthFacade);
  const router = inject(Router);

  return authFacade.stable$.pipe(
    switchMap(() => authFacade.unAuthenticated$),
    map((unAuthenticated) =>
      unAuthenticated ? true : router.createUrlTree(['/', 'auth-redirect']),
    ),
  );
};
